// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"426":"f0151adc","453":"68693753","888":"885b3f31","944":"6e126571"}[chunkId] + ".chunk.js";
};